
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A human-readable name given to the profile.`}</p>
    <p>{`This in addition to the `}<inlineCode parentName="p">{`positionTitle`}</inlineCode>{` can help identify the profile to an end user.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;